
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { TrendingUp } from "lucide-react";

interface MetricCardProps {
  title: string;
  value: string | number;
  description?: string;
  icon: React.ReactNode;
  loading?: boolean;
  trend?: number;
  color?: string;
  currency?: string;
  showCurrency?: boolean;
}

export const MetricCard = ({ 
  title, 
  value, 
  description, 
  icon, 
  loading = false, 
  trend, 
  color = "bg-primary",
  currency = "Ksh",
  showCurrency = false
}: MetricCardProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between py-2 pb-1">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <div className={`p-1.5 rounded-full ${color}/10`}>
          {icon}
        </div>
      </CardHeader>
      <CardContent className="py-1">
        {loading ? (
          <Skeleton className="h-6 w-24" />
        ) : (
          <div className="text-2xl font-bold">
            {showCurrency ? `${currency} ` : ""}{value}
          </div>
        )}
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </CardContent>
      {trend !== undefined && (
        <CardFooter className="pt-0 pb-2">
          <div className={`flex items-center text-xs ${trend >= 0 ? 'text-green-500' : 'text-red-500'}`}>
            <TrendingUp className={`h-3 w-3 mr-1 ${trend < 0 ? 'rotate-180' : ''}`} />
            <span>{Math.abs(trend)}% {trend >= 0 ? 'increase' : 'decrease'}</span>
          </div>
        </CardFooter>
      )}
    </Card>
  );
};
